import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { mediaApi } from "../api";

const MediaAuthContext = createContext(null);

export function MediaAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await mediaApi.me();
      setUser(u);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const u = await mediaApi.login(email, password);
    setUser(u);
    return u;
  };

  const logout = async () => {
    try { await mediaApi.logout(); } catch {}
    setUser(null);
  };

  return (
    <MediaAuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </MediaAuthContext.Provider>
  );
}

export const useMediaAuth = () => useContext(MediaAuthContext);
